/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as AppMatchesIndexRouteImport } from './routes/_app/matches.index'
import { Route as AppPlayersIndexRouteImport } from './routes/_app/players.index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMatchesIndexRoute = AppMatchesIndexRouteImport.update({
  id: '/matches/',
  path: '/matches/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPlayersIndexRoute = AppPlayersIndexRouteImport.update({
  id: '/players/',
  path: '/players/',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/upgrade': typeof UpgradeRoute
  '/matches/': typeof AppMatchesIndexRoute
  '/players/': typeof AppPlayersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/upgrade': typeof UpgradeRoute
  '/matches': typeof AppMatchesIndexRoute
  '/players': typeof AppPlayersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/upgrade': typeof UpgradeRoute
  '/_app/matches/': typeof AppMatchesIndexRoute
  '/_app/players/': typeof AppPlayersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/signup' | '/upgrade' | '/matches/' | '/players/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/signup' | '/upgrade' | '/matches' | '/players'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/signup'
    | '/upgrade'
    | '/_app/matches/'
    | '/_app/players/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  UpgradeRoute: typeof UpgradeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/matches/': {
      id: '/_app/matches/'
      path: '/matches'
      fullPath: '/matches/'
      preLoaderRoute: typeof AppMatchesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/players/': {
      id: '/_app/players/'
      path: '/players'
      fullPath: '/players/'
      preLoaderRoute: typeof AppPlayersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppMatchesIndexRoute: typeof AppMatchesIndexRoute
  AppPlayersIndexRoute: typeof AppPlayersIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppMatchesIndexRoute: AppMatchesIndexRoute,
  AppPlayersIndexRoute: AppPlayersIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  UpgradeRoute: UpgradeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
